import { gql, TypedDocumentNode } from '@apollo/client';
import { CardPaymentMerchantEnum } from '@libs/backend-common';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';

export type DeleteBlocksCardAdditionArgs = DefaultArg<{
  name: CardPaymentMerchantEnum;
}>;

export type DeleteBlocksCardAdditionReponse = DefaultApiResponse<{
  deleteBlocksCardAddition: boolean;
}>;

export const deleteBlocksCardAdditionQuery: TypedDocumentNode<
  DeleteBlocksCardAdditionReponse,
  DeleteBlocksCardAdditionArgs
> = gql`
  query deleteBlocksCardAddition($record: CardPaymentMerchantNameRecord!) {
    deleteBlocksCardAddition(record: $record)
  }
`;
